import { getDownPaymentFilterValue } from '../../utils';

const LOAN_TERM_OPTIONS = [
  {
    value: 10,
    label: '10 лет',
    dataTestId: `loan-term-10`,
  },
  {
    value: 20,
    label: '20 лет',
    dataTestId: `loan-term-20`,
  },
  {
    value: 30,
    label: '30 лет',
    dataTestId: `loan-term-30`,
  },
];

const DOWN_PAYMENT_VALUES = ['20', '30', '40', '50'];

const MIN_OBJECT_COST = 300_000;
const MAX_OBJECT_COST = 100_000_000;

const MIN_DOWN_PAYMENT_PERCENTAGE = 20.1;
const MAX_DOWN_PAYMENT_PERCENTAGE = 99;

const MIN_LOAN_TERM = 1;
const MAX_LOAN_TERM = 30;

export {
  DOWN_PAYMENT_VALUES,
  LOAN_TERM_OPTIONS,
  MAX_DOWN_PAYMENT_PERCENTAGE,
  MAX_LOAN_TERM,
  MAX_OBJECT_COST,
  MIN_DOWN_PAYMENT_PERCENTAGE,
  MIN_LOAN_TERM,
  MIN_OBJECT_COST,
};

export { getDownPaymentFilterValue };
